/**
 * @generated SignedSource<<cd828ba31fc20a211cd2b53ff05a7165>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TicketDashboardAnalyticsInput = {
  dateField?: string | null;
  from: string;
  to: string;
  status?: ReadonlyArray<string> | null;
  priority?: ReadonlyArray<string> | null;
  channel?: ReadonlyArray<string> | null;
  assigneeId?: ReadonlyArray<string> | null;
  includeUnassigned?: boolean | null;
  requesterId?: ReadonlyArray<string> | null;
  labelId?: ReadonlyArray<string> | null;
};
export type DashboardRouteQuery$variables = {
  input: TicketDashboardAnalyticsInput;
};
export type DashboardRouteQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly ticketDashboardAnalytics: {
      readonly gauge: {
        readonly achieved: number;
        readonly breached: number;
        readonly total: number;
        readonly ratePct: number | null;
        readonly targetPct: number;
      };
      readonly trend: ReadonlyArray<{
        readonly date: string;
        readonly created: number;
        readonly resolved: number;
        readonly breached: number;
      }>;
    } | null;
  } | null;
};
export type DashboardRouteQuery = {
  variables: DashboardRouteQuery$variables;
  response: DashboardRouteQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breached",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ],
  "concreteType": "TicketDashboardAnalytics",
  "kind": "LinkedField",
  "name": "ticketDashboardAnalytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketSlaGauge",
      "kind": "LinkedField",
      "name": "gauge",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "achieved",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ratePct",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "targetPct",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketTrendPoint",
      "kind": "LinkedField",
      "name": "trend",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resolved",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "162c7d336142184af59ce1fa129b772b",
    "id": null,
    "metadata": {},
    "name": "DashboardRouteQuery",
    "operationKind": "query",
    "text": "query DashboardRouteQuery(\n  $input: TicketDashboardAnalyticsInput!\n) {\n  viewer {\n    actualPersonId\n    ticketDashboardAnalytics(input: $input) {\n      gauge {\n        achieved\n        breached\n        total\n        ratePct\n        targetPct\n      }\n      trend {\n        date\n        created\n        resolved\n        breached\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ead1309cd56259c3009b3c0a8d747b0b";

export default node;
